import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE = "CTL AUSTRALIA";
const BASE_URL = process.env.REACT_APP_SITE_URL || "https://www.ctlaus.com";
const DEFAULT_TITLE = "The Mining And Industrial Supplier | CTL AUSTRALIA";
const DEFAULT_DESC = "Shop electrical, enclosures, batteries and industrial gear. Fast delivery across WA.";

export default function Seo({
    title,
    description,
    image,
    canonicalPath,     // e.g. "/product-list"
    type = "website",  // "product" for products, etc.
    schema,            // JSON-LD object
    noindex = false
}) {
    const { pathname, search } = useLocation();
    const path = canonicalPath || pathname + (search || "");
    const url = `${BASE_URL}${path}`;
    const pageTitle = title ? `${title} | ${SITE}` : DEFAULT_TITLE;
    const desc = description || DEFAULT_DESC;

    return (
        <Helmet prioritizeSeoTags>
            <title>{pageTitle}</title>
            <meta name="description" content={desc} />
            <meta name="robots" content={noindex ? "noindex,nofollow" : "index,follow"} />
            <link rel="canonical" href={url} />
            {/* Open Graph / Twitter */}
            <meta property="og:type" content={type} />
            <meta property="og:site_name" content={SITE} />
            <meta property="og:title" content={pageTitle} />
            <meta property="og:description" content={desc} />
            <meta property="og:url" content={url} />
            {image && <meta property="og:image" content={image} />}
            <meta name="twitter:card" content="summary_large_image" />
            {/* JSON-LD */}
            {schema && (
                <script type="application/ld+json">
                    {JSON.stringify(schema)}
                </script>
            )}
        </Helmet>
    );
}
